import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import download from "downloadjs";

import "../../static/css/jobsStyle.css";
import user from "../../static/images/user_default.png";
import useOnceEffect from "../../Hooks/useOnceEffect";

function VerCandidatos({ data }) {
  const [listVacants, setlistVacants] = useState([]);
  const location = useLocation();
  const history = useHistory();

  useOnceEffect(() => {
    if (location.state !== undefined) {
      axios
        .get(
          "company-vacant/list-details-vacants/" +
            location.state.vacante.companyVacantId
        )
        .then((result) => {
          setlistVacants(result.data);
        });
    } else {
      alert("aqui");
      window.location.replace("/company/Vacante/EstadoVacantes");
    }
    SetTab();
  });

  function ChangeState(id) {
    axios
      .post("access/applicant-vacant-set/" + id)
      .then((result) => {
        if (result.status === 200) {
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      })
      .catch((e) => {
        if (!e.status) {
          toast.error(
            "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
            { duration: 5000 }
          );
        }
      });
  }

  function SetTab() {
    document
      .getElementById("pills-tab3")
      .setAttribute("className", "nav-link active");
    document.getElementById("pills-tab1").setAttribute("className", "nav-link");
  }

  const DownloadCv = (id, name, lastname) => {
    axios
      .get("access/pdf-cv/" + id, {
        responseType: "blob", // had to add this one here
      })
      .then((result) => {
        if (result.status === 200) {
          const content = result.headers["content-type"];
          download(result.data, "CV_" + name + " " + lastname, content);
          toast.success("Descargando", {
            duration: 4000,
          });
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      })
      .catch((e) => {
        if (!e.status) {
          toast.error(
            "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
            { duration: 5000 }
          );
        }
      });
  };

  const Downloadtest = (id, name, lastname) => {
    axios
      .get("/applicant-vacant-test/download-file", {
        params: {
          applicantId: id,
          companyVacantId: location.state.vacante.companyVacantId,
        },
        responseType: "blob", // had to add this one here
      })
      .then((result) => {
        if (result.status === 200) {
          const content = result.headers["content-type"];
          let filename =
            result.headers["filename"] ??
            "Test_" + name + "_" + lastname + ".pdf";

          download(result.data, filename, content);
          toast.success("Descargando", {
            duration: 4000,
          });
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      })
      .catch((e) => {
        if (!e.status) {
          toast.error(
            "El candidato " +
              name +
              " " +
              lastname +
              "," +
              " No ha subido archivo con respuesta",
            { duration: 5000 }
          );
        }
      });
  };

  return (
    <div className="content" style={{ width: "100%" }}>
      <div className="internal-navigation">
        <Link className="back-button" to="/company/Vacante/EstadoVacantes">
          <span className="back-button__icon"></span>Regresar al Estado de tus
          vacantes
        </Link>
      </div>

      <div className="row mt-5">
        <h6>Vacantes y Pasantías Publicadas</h6>
        <p className="mt-4">Personaliza el estado de vacante</p>
        <div className="col-md-12">
          <div className="steps-box mb-4">
            <div className="row">
              <div className="col-md-6">
                <p className="tit">{location.state?.vacante.cargo ?? ""}</p>
              </div>
              <div className="col-md-6 text-end">
                <p className="sub-tit">
                  Fecha de Creación:{" "}
                  <span>{location.state?.vacante.fechaPublicacion ?? ""}</span>
                </p>
                <p className="sub-tit">
                  Estado:{" "}
                  <span>
                    {location.state?.vacante.esVigente ? "Activo" : "Cerrada"}
                  </span>
                </p>
              </div>
            </div>
            <div className="process-wrapper">
              <div id="progress-bar-container">
                <ul>
                  {location.state?.etapas.map((item, index) => {
                    return (
                      <li
                        key={index}
                        className={
                          item.completado
                            ? "step stepA1" + item.orden + " active"
                            : "step stepA" + item.orden
                        }
                      >
                        <div className="step-inner">{item.nombreEtapa}</div>
                      </li>
                    );
                  })}
                </ul>
                <div id="line">
                  <div id="line-progress"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="jobsTab3" className="dataTable">
        <div className="dataTable__filter">
          <span>Ordenar por:</span>
          <select name="filter">
            <option value="mas-reciente">Más reciente</option>
          </select>
        </div>
        <div className="dataTable__table">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Candidatos</th>
                <th scope="col">Telefono</th>
                <th scope="col">Habilidades(%)</th>
                <th scope="col">Test</th>
                <th scope="col">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {listVacants.map((item, index) => {
                return (
                  <tr
                    key={index}
                    className={item.test === null ? "pendiente" : ""}
                  >
                    <td>
                      <Link
                        className="user"
                        to={{
                          pathname: "/company/Candidato",
                          state: {
                            userid: item.applicantId,
                          },
                        }}
                        onClick={() => ChangeState(item.aplicarVacanteId)}
                      >
                        <span className="user__icon">
                          <img
                            src={
                              item.photoProfileApplicant !== null
                                ? item.photoProfileApplicant
                                : user
                            }
                            style={{
                              borderRadius: "50%",
                              width: "58px",
                              height: "58px",
                            }}
                            alt="Profile Icon"
                          ></img>
                        </span>
                        {item.names} {item.lastnames}
                        {item.nuevo ? (
                          <span
                            className="badge bg-success"
                            style={{ marginLeft: "10px", display: "inline" }}
                          >
                            Nuevo
                          </span>
                        ) : (
                          ""
                        )}
                      </Link>
                    </td>
                    <td>
                      <p style={{ fontSize: ".75rem", color: "grey" }}>
                        {item?.profile?.userId?.telephone}
                      </p>
                    </td>
                    <td>
                      <p style={{ fontSize: ".75rem", color: "grey" }}>
                        El Candidato cumple con el
                        <span className="c-skill">{item.habilidades}% </span>
                        de las habilidades requeridas para el puesto
                      </p>
                    </td>
                    <td className="c-test">
                      <button
                        type="button"
                        class="btn btn-light"
                        onClick={() =>
                          Downloadtest(
                            item.applicantId,
                            item.names,
                            item.lastnames
                          )
                        }
                      >
                        Descargar test
                      </button>
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-light float-left me-2"
                        onClick={() =>
                          DownloadCv(
                            item.applicantId,
                            item.names,
                            item.lastnames
                          )
                        }
                      >
                        Descargar CV
                      </button>
                      <button
                        type="button"
                        class="btn btn-light"
                        onClick={() =>
                          history.push(
                            `/company/chat?create=${item?.profile?.userId?.userId}`
                          )
                        }
                      >
                        Enviar Mensaje
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default VerCandidatos;
